module.exports = __webpack_public_path__ + "static/img/Snapchat-.6755f294.png";